export default {"src":"/_next/static/media/messages.8ebf97f2.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};